import { render, staticRenderFns } from "./ModalDomain.vue?vue&type=template&id=72cf37bb&scoped=true"
import script from "./ModalDomain.vue?vue&type=script&lang=js"
export * from "./ModalDomain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cf37bb",
  null
  
)

export default component.exports